import React, {FC, RefObject} from 'react'
import { EnhancedTicket } from '../../../../app/@contexts';
import { Link } from 'react-router-dom';
import { PATH_SUPPORT } from '../../../../app/routing/paths';
import { TruncateText, StripHtml } from '../../../../app/features';

interface SavTabPaneProps {
  items: EnhancedTicket[];
  scrollRef: RefObject<HTMLDivElement>;
}

const SavTabPane: FC<SavTabPaneProps> = ({ items, scrollRef  }) => (
  <div className="tab-pane fade show active" id="kt_top_bar_notifications_1" role="tabpanel">
    <div className="scroll-y mh-325px px-3 pt-5" ref={scrollRef}>
      {items.map((item, index) => (
        <div className="row mb-5" key={index}>
          <div className="col-3">
            <span className="fs-7">{item.created_at}</span>
          </div>
          <div className="col-9">
            <div className="flex-grow-1">
              <Link to={`${PATH_SUPPORT.ticket}/${item.ticket_id}`}
                    className="text-gray-800 text-hover-primary fw-bolder fs-6">{TruncateText(item.subject, 20)}</Link>
              <span
                className="text-muted fw-bold d-block">{TruncateText(StripHtml(item.message), 50)}</span>
            </div>
          </div>
        </div>
      ))}
      {/*{items.length > 0 ? (*/}
      {/*  <>*/}
      {/*    {items.map((item, index) => (*/}
      {/*      <div className="row mb-5" key={index}>*/}
      {/*        <div className="col-3">*/}
      {/*          <span className="fs-7">{item.created_at}</span>*/}
      {/*        </div>*/}
      {/*        <div className="col-9">*/}
      {/*          <div className="flex-grow-1">*/}
      {/*            <Link to={`${PATH_SUPPORT.ticket}/${item.ticket_id}`}*/}
      {/*                  className="text-gray-800 text-hover-primary fw-bolder fs-6">{TruncateText(item.subject, 20)}</Link>*/}
      {/*            <span*/}
      {/*              className="text-muted fw-bold d-block">{TruncateText(StripHtml(item.message), 50)}</span>*/}
      {/*          </div>*/}
      {/*        </div>*/}
      {/*      </div>*/}
      {/*    ))}*/}
      {/*    <div className="mt-3 text-center border-top">*/}
      {/*      <Link to={PATH_SUPPORT.root} className="btn btn-color-gray-600 btn-active-color-primary">*/}
      {/*        Tout afficher <KTSVG path="/media/icons/duotune/arrows/arr064.svg" className="svg-icon-5" />*/}
      {/*      </Link>*/}
      {/*    </div>*/}
      {/*  </>*/}
      {/*) : null}*/}
    </div>
  </div>
);

export default SavTabPane;